import {Component, OnInit, ViewChild} from '@angular/core';
import {MenuItem, MessageService} from 'primeng/api';
import {ShipmentInstructionService} from '../@shared/new-services/shipment-instruction.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {CargoDetailsComponent} from './cargo-details/cargo-details.component';
import {ContainerDetailsComponent} from './container-details/container-details.component';
import {UserMgmtService} from '../@shared/new-services/user-mgmt.service';
import {UserContactManagementComponent} from './user-contact-management/user-contact-management.component';
import {FileUpload} from 'primeng/fileupload';
import * as _ from 'lodash';

interface Commodity {
    commodityCode: string;
    commodityDescription: string;
}

enum PartyDetails {
    shipper = 'SHIPPER',
    consignee = 'CONSIGNEE',
    firstNotifyParty = 'FIRST_NOTIFY_PARTY',
    secondNotifyParty = 'SECOND_NOTIFY_PARTY',
}

@Component({
    selector: 'shipment-instruction-form',
    templateUrl: './shipping-instruction.component.html',
    styleUrls: ['./shipping-instruction.component.scss']
})
export class ShippingInstructionComponent implements OnInit {

    // Components
    @ViewChild('cargoDetails') cargoDetailsComponent: CargoDetailsComponent; // CargoDetails
    @ViewChild('containerDetails') containerDetailsComponent: ContainerDetailsComponent; // ContainerDetails
    @ViewChild('userContactManagement') userContactManagementComponent: UserContactManagementComponent; // UserContactManagement


    // DialogBoxes Variable
    displayUserContactManagement = false; // To Manage User Contacts(Shipper, Consignee, ..)
    displaySubmitSIDialog = false; // SI Preview Dialog

    isLoading = false; // Loader/Spinner
    isLoadingContacts = false; // Loader for userContacts
    isSubmittingSI = false; // Loader for Submit SI Button

    // BreadCrumbs
    home: MenuItem = {icon: 'pi pi-home', routerLink: '/booking-summary'};
    breadcrumbMenuModel: MenuItem[] = [];

    // Main SI Variables
    bookingId: string;
    shipmentType: string;
    shipmentInstruction: any;
    shipmentInstructionForm: FormGroup;
    siFormAction = localStorage.getItem('si-action');

    // UserContacts
    shipperContacts: any[] = [];
    consigneeContacts: any[] = [];
    firstNotifyPartyContacts: any[] = [];
    secondNotifyPartyContacts: any[] = [];
    contactFormAction: string;
    countries: any;
    previewSIObject = null;

    constructor(private shipmentInstructionService: ShipmentInstructionService,
                private activatedRoute: ActivatedRoute,
                private messageService: MessageService,
                private userMgmtService: UserMgmtService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.activatedRoute
            .queryParams.subscribe((param) => {
            this.bookingId = param?.bookingId;
            this.shipmentType = param?.shipmentType;
        });
        this.getShipmentInstruction(this.bookingId); // GET SI by BookingId
        this.createShipmentInstructionForm(); // Create New SI Form
        this.getCountries();
        // this.getUserContacts();
    }

    getShipmentInstruction(bookingId?: string) {
        this.shipmentInstruction = null;
        this.isLoading = true;
        this.shipmentInstructionService
            .getShipmentInstructionsByBookingId(bookingId)
            .subscribe((shipmentInstruction) => {
                this.shipmentInstruction = shipmentInstruction;
                this.breadcrumbMenuModel = [
                    {label: 'Booking Summary', routerLink: '/booking-summary'},
                    {label: 'Shipping Instruction : ' + shipmentInstruction?.bookingId}
                ];
                this.createShipmentInstructionForm(shipmentInstruction); // Creating Form with Data from API
                this.getCountries(); // For UserContact Management GET Countries
                this.isLoading = false;
                if (shipmentInstruction?.shipper) {
                    this.shipmentInstruction.shipper.isEditable = true;
                }
                if (shipmentInstruction?.consignee) {
                    this.shipmentInstruction.consignee.isEditable = true;
                }
                if (shipmentInstruction?.firstNotifyParty) {
                    this.shipmentInstruction.firstNotifyParty.isEditable = true;
                }
                if (shipmentInstruction?.secondNotifyParty) {
                    this.shipmentInstruction.secondNotifyParty.isEditable = true;
                }

                this.getUserContacts(true); // GET UserContacts
            }, (error) => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
                this.isLoading = false;
            });
    }

    bindSiContainersValue(siContainers: any) {
        console.log(siContainers);
        this.shipmentInstructionForm.value.siContainers = siContainers;
    }

    getCountries() {
        this.shipmentInstructionService.getCountries()
            .subscribe((countries) => {
                this.countries = countries;
            }, error => {
                this.presentToastMessage('error', error?.message ? error?.message : error);

            });
    }

    getUserContacts(toValidateUserContact: boolean = false, makeShipperDropdownNull: boolean = false,
                    makeConsigneeDropdownNull: boolean = false,
                    makeFirstNotifyDropdownNull: boolean = false,
                    makeSecondNotifyDropdownNull: boolean = false) {
        this.isLoadingContacts = true;

        this.userMgmtService
            .getUserContacts('SHIP_FROM_SHIP_TO')
            .subscribe((userContacts) => {
                userContacts?.map((userContact) => {
                    userContact.isEditable = true;
                });
                this.shipperContacts = userContacts?.length > 0 ? userContacts : [];
                this.consigneeContacts = userContacts?.length > 0 ? userContacts : [];
                this.firstNotifyPartyContacts = userContacts?.length > 0 ? userContacts : [];
                this.secondNotifyPartyContacts = userContacts?.length > 0 ? userContacts : [];


                if (toValidateUserContact) {
                    this.validateExistingUserContact(PartyDetails.shipper,
                        userContacts, this.shipmentInstruction.shipper,
                        makeShipperDropdownNull, false, false, false);
                    this.validateExistingUserContact(PartyDetails.consignee,
                        userContacts, this.shipmentInstruction.consignee, false,
                        makeConsigneeDropdownNull, false, false);
                    this.validateExistingUserContact(PartyDetails.firstNotifyParty,
                        userContacts, this.shipmentInstruction.firstNotifyParty,
                        false, false, makeFirstNotifyDropdownNull, false);
                    this.validateExistingUserContact(PartyDetails.secondNotifyParty,
                        userContacts, this.shipmentInstruction.secondNotifyParty, false, false, false,
                        makeSecondNotifyDropdownNull);
                }
                // tslint:disable-next-line:no-shadowed-variable
            }, (error) => {
                this.isLoadingContacts = false;
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
        this.isLoadingContacts = false;
    }

    validateExistingUserContact(forWhomToValidate: string, userContacts: any[] = [], userContactToValidate,
                                makeShipperDropdownNull: boolean = false,
                                makeConsigneeDropdownNull: boolean = false,
                                makeFirstNotifyDropdownNull: boolean = false,
                                makeSecondNotifyDropdownNull: boolean = false) {
        const allowUserContactToEdit = userContacts?.map((userContact) => {
            return _.isEqual(userContact, userContactToValidate);
        });
        const checker = arr => allowUserContactToEdit.every(contact => contact === false);
        if (checker(allowUserContactToEdit) && forWhomToValidate === PartyDetails.shipper) {
            if (this.shipmentInstruction.shipper) {
                this.shipmentInstruction.shipper.isEditable = false;
                this.shipperContacts.unshift(this.shipmentInstruction.shipper);
            }
            makeShipperDropdownNull
                ? this.shipmentInstructionForm.controls?.shipper.setValue(null)
                :
                this.shipmentInstructionForm.controls?.shipper.setValue(this.shipmentInstruction.shipper);
        }
        if (checker(allowUserContactToEdit) && forWhomToValidate === PartyDetails.consignee) {
            if (this.shipmentInstruction.consignee) {
                this.shipmentInstruction.consignee.isEditable = false;
                this.consigneeContacts.unshift(this.shipmentInstruction.consignee);
            }

            makeConsigneeDropdownNull
                ? this.shipmentInstructionForm.controls?.consignee.setValue(null)
                : this.shipmentInstructionForm.controls?.consignee.setValue(this.shipmentInstruction.consignee);
        }
        if (checker(allowUserContactToEdit) && forWhomToValidate === PartyDetails.firstNotifyParty) {
            if (this.shipmentInstruction.firstNotifyParty) {
                this.shipmentInstruction.firstNotifyParty.isEditable = false;
                this.firstNotifyPartyContacts.unshift(this.shipmentInstruction.firstNotifyParty);
            }
            makeFirstNotifyDropdownNull
                ? this.shipmentInstructionForm.controls?.firstNotifyParty.setValue(null)
                : this.shipmentInstructionForm.controls?.firstNotifyParty.setValue(this.shipmentInstruction.firstNotifyParty);
        }
        if (checker(allowUserContactToEdit) && forWhomToValidate === PartyDetails.secondNotifyParty) {
            if (this.shipmentInstruction.secondNotifyParty) {
                this.shipmentInstruction.secondNotifyParty.isEditable = false;
                this.secondNotifyPartyContacts.unshift(this.shipmentInstruction.secondNotifyParty);
            }
            makeSecondNotifyDropdownNull
                ? this.shipmentInstructionForm.controls?.secondNotifyParty.setValue(null)
                : this.shipmentInstructionForm.controls?.secondNotifyParty.setValue(this.shipmentInstruction.secondNotifyParty);
        }
    }

    // TO open User Contact Dialog
    addEditUserContact(action: string, partyType: string, userContact?: any) {
        if (action === 'edit') {
            if (!userContact?.isEditable) {
                this.presentToastMessage('info', 'You cannot edit this user contact !');
                return;
            }
        }
        this.displayUserContactManagement = true;
        this.contactFormAction = action;
        if (action === 'edit') {
            this.userMgmtService.getUserContactByUserContactId(userContact?.userContactId)
                .subscribe((userContactRes) => {
                    userContactRes.partyType = partyType;
                    this.userContactManagementComponent.populateUserContactForm(userContactRes);
                });
            return;
        }
        this.userContactManagementComponent.populateUserContactForm();

    }

    manageUserContact() {
        const userContactValue = this.userContactManagementComponent.emitUserContactFormValue();
        if (!userContactValue?.companyName) {
            this.presentToastMessage('info', 'Company Name is Required !');
            return;
        }
        if (!userContactValue?.emailId || !this.validateEmail(userContactValue?.emailId)) {
            this.presentToastMessage('info', 'Invalid Email, Please check !');
            return;
        }
        if (!userContactValue?.address) {
            this.presentToastMessage('info', 'Address is Required !');
            return;
        }
        if (!userContactValue?.country) {
            this.presentToastMessage('info', 'Please Select Country !');
            return;
        }

        if (this.contactFormAction === 'edit') {
            this.updateUserContactService(userContactValue);
            return;
        }
        this.createUserContactService(userContactValue);
    }


    createUserContactService(userContactPayload: any) {
        this.isLoadingContacts = true;
        this.userMgmtService
            .createUserContact('SHIPPER', userContactPayload)
            .subscribe((userContact) => {
                this.isLoadingContacts = false;
                this.presentToastMessage('success',
                    'User Contact Created SuccessFully' + userContact?.companyName);
                if (userContactPayload?.partyType === 'SHIPPER') {
                    this.shipmentInstructionForm?.controls?.shipper?.setValue(null);
                    this.getUserContacts(true,
                        true); // To repopulate Party Details Dropdowns
                }

                if (userContactPayload?.partyType === 'CONSIGNEE') {
                    this.shipmentInstructionForm?.controls?.consignee?.setValue(null);
                    this.getUserContacts(true,
                        false, true); // To repopulate Party Details Dropdowns
                }

                if (userContactPayload?.partyType === 'FIRST_NOTIFY_PARTY') {
                    this.shipmentInstructionForm?.controls?.firstNotifyParty?.setValue(null);
                    this.getUserContacts(true, false,
                        false, true); // To repopulate Party Details Dropdowns
                }

                if (userContactPayload?.partyType === 'SECOND_NOTIFY_PARTY') {
                    this.shipmentInstructionForm?.controls?.secondNotifyParty?.setValue(null);
                    this.getUserContacts(true,
                        false, false, false,
                        true); // To repopulate Party Details Dropdowns
                }
                this.displayUserContactManagement = false;
                this.getUserContacts(true);

            }, (error) => {
                this.isLoadingContacts = false;
                this.presentToastMessage('error',
                    error?.message ? error?.message : error);
            });
    }

    updateUserContactService(userContactPayload: any) {
        this.isLoadingContacts = true;
        this.userMgmtService
            .updateUserContact(userContactPayload)
            .subscribe((userContact) => {
                this.isLoadingContacts = false;
                this.presentToastMessage('success', 'User Contact : ' + userContact?.companyName + ' Updated !');
                this.displayUserContactManagement = false;
                if (userContactPayload?.partyType === 'SHIPPER') {
                    this.shipmentInstructionForm?.controls?.shipper?.setValue(null);
                    this.getUserContacts(true,
                        true); // To repopulate Party Details Dropdowns
                }

                if (userContactPayload?.partyType === 'CONSIGNEE') {
                    this.shipmentInstructionForm?.controls?.consignee?.setValue(null);
                    this.getUserContacts(true,
                        false, true); // To repopulate Party Details Dropdowns
                }

                if (userContactPayload?.partyType === 'FIRST_NOTIFY_PARTY') {
                    this.shipmentInstructionForm?.controls?.firstNotifyParty?.setValue(null);
                    this.getUserContacts(true, false,
                        false, true); // To repopulate Party Details Dropdowns
                }

                if (userContactPayload?.partyType === 'SECOND_NOTIFY_PARTY') {
                    this.shipmentInstructionForm?.controls?.secondNotifyParty?.setValue(null);
                    this.getUserContacts(true,
                        false, false, false,
                        true); // To repopulate Party Details Dropdowns
                }
            }, error => {
                this.isLoadingContacts = false;
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    saveDraftSI() {
        console.log(this.shipmentType)
        if (this.shipmentType === 'AIR') {
            this.cargoDetailsComponent.emitCargoDetailsValue();
        }
        if (this.shipmentType !== 'AIR') {
            this.containerDetailsComponent.emitContainerDetailsValue();
        }
        const siPayload = this.shipmentInstructionForm.value;

        // Validations
        const commodityValidator = siPayload.siContainers?.map((container, index) => {
            const commodity: Commodity = container.commodity;
            if (typeof commodity !== 'object') {
                this.presentToastMessage('error',
                    'Invalid Commodity at Form [' + ((index + 1) + ' OF ' + (siPayload?.siContainers?.length)) + '] !');
            }
            return typeof commodity === 'object';
        });
        const checker = arr => commodityValidator.every(commodityValid => commodityValid === true);
        if (!checker(commodityValidator)) {
            return;
        }

        // Port of Discharge Editable
        if (!siPayload?.portOfDischargeEditable) {
            this.presentToastMessage('info', 'Please Enter Additional Port of Discharge !');
            return;
        }


        // Final Place of Delivery Editable
        if (!siPayload?.finalPlaceOfDeliveryEditable) {
            this.presentToastMessage('info', 'Please Enter Additional Final Place of Delivery !');
            return;
        }

        siPayload?.siContainers?.map((cargo, i) => {

        });

        this.saveDraftSIService(siPayload);
    }

    saveDraftSIService(siPayload: any) {
        this.shipmentInstructionService
            .saveDraftSI(this.bookingId, siPayload)
            .subscribe((x) => {
                this.getShipmentInstruction(this.bookingId);
                this.siFormAction = 'edit';
                this.presentToastMessage('success', 'SI Drafted SuccessFully !');
                // tslint:disable-next-line:no-shadowed-variable
            }, error => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }


    submitShipmentInstructions() {
        if (this.shipmentType === 'AIR') {
            this.cargoDetailsComponent.emitCargoDetailsValue();
        }
        if (this.shipmentType !== 'AIR') {
            this.containerDetailsComponent.emitContainerDetailsValue();
        }
        const siPayload = this.shipmentInstructionForm.value;

        // Validations

        const commodityValidator = siPayload.siContainers?.map((container, index) => {
            const commodity: Commodity = container.commodity;
            if (typeof commodity !== 'object') {
                this.presentToastMessage('error',
                    'Invalid Commodity at Form [' + ((index + 1) + ' OF ' + (siPayload?.siContainers?.length)) + '] !');
            }
            return typeof commodity === 'object';
        });
        const checker = arr => commodityValidator.every(commodityValid => commodityValid === true);
        if (!checker(commodityValidator)) {
            return;
        }


        // Port of Discharge Editable
        if (!siPayload?.portOfDischargeEditable) {
            this.presentToastMessage('info', 'Please Enter Additional Port of Discharge !');
            return;
        }


        // Final Place of Delivery Editable
        if (!siPayload?.finalPlaceOfDeliveryEditable) {
            this.presentToastMessage('info', 'Please Enter Additional Final Place of Delivery !');
            return;
        }
        this.submitSIService(siPayload);
    }

    submitSIService(siPayload: any) {
        this.isSubmittingSI = true;
        this.shipmentInstructionService
            .submitSI(this.bookingId, siPayload)
            .subscribe((x) => {
                this.isSubmittingSI = false;
                this.presentToastMessage('success', 'SI Submitted SuccessFully !');
                this.displaySubmitSIDialog = true;
                this.previewSIObject = x;
                // tslint:disable-next-line:no-shadowed-variable
            }, error => {
                this.isSubmittingSI = false;
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    uploadSIContainerDocument(event: any) {
        const documentTypeId = event?.documentTypeId;
        const files = event?.files;
        const cargoDetails = event?.cargoDetails;
        const fileUploadComponent = event?.fileUploadComponent;
        this.uploadShippingInstructionContainerDocumentsService(documentTypeId, files[0], cargoDetails, fileUploadComponent);
    }

    uploadShippingInstructionContainerDocumentsService(documentTypeId: any, multipartFiles: any, cargoDetails: any,
                                                       fileUploadComponent: FileUpload) {
        fileUploadComponent.uploading = true;
        this.shipmentInstructionService
            .uploadShippingInstructionContainerDocuments(documentTypeId, this.bookingId, multipartFiles,
                cargoDetails?.shipUnitId)
            .subscribe((x) => {
                fileUploadComponent.uploading = false;
                this.presentToastMessage('success', documentTypeId + ' Document Uploaded Successfully !');
                fileUploadComponent.clear();
                this.saveDraftSI();
            }, error => {
                fileUploadComponent.uploading = false;
                this.presentToastMessage('error', error?.message ? error?.message : error);
                fileUploadComponent.clear();
            });
    }

    uploadSIDocuments(event: any, documentTypeId: any, fileUploadComponent: FileUpload) {
        const multipartFiles = event?.files;
        this.uploadSIDocumentsService(documentTypeId, multipartFiles, fileUploadComponent);
    }

    uploadSIDocumentsService(documentTypeId: any, multiPartFiles: any[], fileUploadComponent: FileUpload) {
        this.shipmentInstructionService
            .uploadSIDocuments(documentTypeId, this.bookingId, multiPartFiles)
            .subscribe((x) => {
                fileUploadComponent.uploading = false;
                this.presentToastMessage('success', documentTypeId + ' Document Uploaded Successfully !');
                this.saveDraftSI();
                fileUploadComponent.clear();
            }, error => {
                fileUploadComponent.uploading = false;
                this.presentToastMessage('error', error?.message ? error?.message : error);
                fileUploadComponent.clear();
            });
    }

    displaySIDocumentsList(event: any) {
        event?.currentFiles?.map((x) => {
            this.shipmentInstructionForm.value.siDocuments.push(x);
        });
        // thils.shipmentInstructionForm.value.siDocuments = (event?.currentFiles);
    }

    deleteSiDocumentBySiDocId(siDocId: any) {
        this.shipmentInstructionService
            .deleteSIDocumentBySIDocId(siDocId)
            .subscribe(
                (x) => {
                    this.presentToastMessage('success', 'Document Deleted !');
                    this.saveDraftSI();
                }, error => {
                    this.presentToastMessage('error', error?.message ? error?.message : error);
                }
            );
    }

    removeNotUploadedDocuments(index: number) {
        this.shipmentInstructionForm?.value?.siDocuments.forEach((value, i) => {
            if (i === index) {
                this.shipmentInstructionForm?.value?.siDocuments.splice(index, 1);
            }
        });
    }

    navigateToPreviewSI(booking: any) {
        this.router
            .navigate(
                ['/', 'preview-si'], {
                    queryParams: {
                        bookingId: booking?.bookingId,
                        shipmentType: booking?.shipmentType,
                    }
                }
            );
    }

    presentToastMessage(severity, detail) {
        this.messageService
            .add(
                {
                    severity,
                    summary: 'Shipment Instruction Message',
                    key: 'shipment-instruction-message',
                    detail,
                }
            );
    }

    createShipmentInstructionForm(shipmentInstruction?: any) {
        this.shipmentInstructionForm = new FormGroup({

            // Required Backend Fields
            bookingId: new FormControl(shipmentInstruction?.bookingId ? shipmentInstruction?.bookingId : ''),
            domainName: new FormControl(shipmentInstruction?.domainName ? shipmentInstruction?.domainName : ''),
            siId: new FormControl(shipmentInstruction?.siId ? shipmentInstruction?.siId : ''),
            shipmentType: new FormControl(shipmentInstruction?.shipmentType ? shipmentInstruction?.shipmentType : this.shipmentType),

            // Shipment Details
            placeOfReceipt: new FormControl(shipmentInstruction?.placeOfReceipt ? shipmentInstruction?.placeOfReceipt : ''),
            placeOfReceiptEditable: new FormControl(shipmentInstruction?.placeOfReceiptEditable ?
                shipmentInstruction?.placeOfReceiptEditable : ''),
            portOfLoading: new FormControl(shipmentInstruction?.portOfLoading ? shipmentInstruction?.portOfLoading : ''),
            portOfLoadEditable: new FormControl(shipmentInstruction?.portOfLoadEditable ? shipmentInstruction?.portOfLoadEditable : ''),
            portOfDischarge: new FormControl(shipmentInstruction?.portOfDischarge ? shipmentInstruction?.portOfDischarge : ''),
            portOfDischargeEditable: new FormControl(shipmentInstruction?.portOfDischargeEditable ?
                shipmentInstruction?.portOfDischargeEditable : ''),
            finalPlaceOfDelivery: new FormControl(shipmentInstruction?.finalPlaceOfDelivery ?
                shipmentInstruction?.finalPlaceOfDelivery : ''),
            finalPlaceOfDeliveryEditable: new FormControl(shipmentInstruction?.finalPlaceOfDeliveryEditable ?
                shipmentInstruction?.finalPlaceOfDeliveryEditable : ''),

            // Party Details
            shipper: new FormControl(shipmentInstruction?.shipper ?
                shipmentInstruction?.shipper : null),
            consignee: new FormControl(shipmentInstruction?.consignee ?
                shipmentInstruction?.consignee : null),
            firstNotifyParty: new FormControl(shipmentInstruction?.firstNotifyParty ?
                shipmentInstruction?.firstNotifyParty : null),
            secondNotifyParty: new FormControl(shipmentInstruction?.secondNotifyParty ?
                shipmentInstruction?.secondNotifyParty : null),

            // Cargo Description
            cargoDescription: new FormControl(shipmentInstruction?.cargoDescription ?
                shipmentInstruction?.cargoDescription : ''),
            cargoDescriptionAddon: new FormControl(shipmentInstruction?.cargoDescriptionAddon ?
                shipmentInstruction?.cargoDescriptionAddon : ''),

            // Marks & Numbers
            isMarksAndNumber: new FormControl(!!shipmentInstruction?.isMarksAndNumber),
            marksAndNumber: new FormControl(shipmentInstruction?.marksAndNumber ? shipmentInstruction?.marksAndNumber : ''),

            // Freight Payment Terms
            freightTerm: new FormControl(shipmentInstruction?.freightTerm ? shipmentInstruction?.freightTerm : 'prepaid'),

            // Special Instructions
            specialInstruction: new FormControl(shipmentInstruction?.specialInstruction ? shipmentInstruction?.specialInstruction : ''),

            // Special Handling Instructions
            specialHandlingInstruction: new FormControl(shipmentInstruction?.specialHandlingInstruction
                ? shipmentInstruction?.specialHandlingInstruction : ''),

            // L/C Shipment
            isLcShipment: new FormControl(!!shipmentInstruction?.isLcShipment),
            lcNotes: new FormControl(shipmentInstruction?.lcNotes ? shipmentInstruction?.lcNotes : ''),
            lcDocument: new FormControl(shipmentInstruction?.lcDocument ? shipmentInstruction?.lcDocument : null),

            // Is Original Doc
            isOriginalDocument: new FormControl(shipmentInstruction?.isOriginalDocument ? this.shipmentType !== 'AIR' ?
                null : true : shipmentInstruction?.isOriginalDocument),

            // Container / Cargo Details
            siContainers: new FormArray([]),

            // SI Documents
            siDocuments: new FormControl(shipmentInstruction?.siDocuments ? shipmentInstruction?.siDocuments : []),

            // Customer Reference Number
            customerReferenceNumber: new FormControl(shipmentInstruction?.customerReferenceNumber
                ? shipmentInstruction?.customerReferenceNumber : '')
        });
    }

    // To Validate Email Address
    validateEmail(email: any) {
        const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regularExpression.test(String(email).toLowerCase());
    }

    getDocumentByDocumentTypeId(siPayload: any, documentTypeId: string): any {
        if (documentTypeId === 'LC_DOCUMENT') {
            const index = siPayload?.siDocuments?.findIndex(document => document.documentTypeId === documentTypeId);
            return siPayload?.siDocuments[index];
        }
        if (documentTypeId === 'SI_DOCUMENTS') {
            const documents = siPayload?.siDocuments?.map((document, i) => {
                if (document?.documentTypeId === documentTypeId) {
                    return document;
                } else {
                    return;
                }
            });
            const filteredDoc = _.remove(documents, (document) => {
                return document !== undefined;
            });
            return filteredDoc;
        }


    }

}
